import CreateAccess from 'models/access/createAccess';
import AccessResource from 'models/access/resource';
import React from 'react';

interface AccessDef {
  createAccess: (binding: CreateAccess) => Promise<void>;
  deleteAccess: (access: AccessResource) => Promise<void>;
}
export const Context = React.createContext<AccessDef>({
  createAccess: async () => undefined,
  deleteAccess: async () => undefined,
});

export default Context;

export interface SelectionValue {
  deleting?: AccessResource;

}

export interface SelectionContextValue {
  selection: SelectionValue;
  setSelection: (value: SelectionValue) => void;
}

export const SelectionContext = React.createContext<SelectionContextValue>({
  selection: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelection: () => {},
});
